export { GlobalCommandPalette } from './GlobalCommandPalette';
export { GlobalCommandPaletteInput } from './GlobalCommandPaletteInput';
export type { GlobalCommandPaletteInputProps } from './GlobalCommandPaletteInput';

// AccessoryCount, isAccessoryCount and isIconConfig are exported from TanStackTable/CommandPalette.
export type {
    GlobalCommandConfirmation,
    GlobalCommandContext,
    GlobalCommandDefinition,
    GlobalCommandIcon,
    GlobalCommandPaletteProps,
    GlobalQuickLookConfig,
    SearchableResource,
} from './types';

export {
    attrs,
    CMDK_STYLES,
    CommandPaletteFooter,
    formatAccessoryCount,
    HintButton,
    injectCmdkStyles,
    isMacPlatform,
    KeyboardBadge,
    matchShortcut,
    useIsMac,
    useKeyboardNavigation,
    usePaletteAnalytics,
    usePaletteOpenEffect,
    VisuallyHidden,
} from './shared';
export type { PaletteEventAttrs, PaletteEventKind } from './shared';
